import type {
  Round,
  Sg2Round,
  StartRoundPayload,
  StartUnityGameDto,
} from "Models";
import { normalize } from "normalizr";
import type { AppQueryConfig, MoveRoundPayload } from "QueryTypes";
import { round } from "./roundSchema";
import type { RoundsEntitiesState } from "StoreTypes";
import { config } from "@/config/env";
import {
  clubhouseApiHeadersV1,
  clubhouseApiHeadersV2,
} from "utils/api/apiHelper";

const urls = {
  roundById(roundId: string): string {
    return `${config.apiBaseUrl}/api/rounds/${roundId}`;
  },
  startRound(_facilityId: string, simulatorId: string): string {
    return `${config.apiBaseUrl}/api/simulators/${simulatorId}/startround`;
  },
  moveRound(roundId: string): string {
    return `${config.apiBaseUrl}/api/rounds/${roundId}/move/`;
  },
  startUnityGame(facilityId: string, simulatorId: string): string {
    return `${config.apiBaseUrl}/api/unity/facility/${facilityId}/simulator/${simulatorId}/start_unity_game`;
  },
};

export const getRoundByIdQuery = (
  roundId: string,
): AppQueryConfig | undefined => {
  if (!roundId?.trim()) {
    console.log("roundId is falsy or empty");
    return undefined; // exit early if roundId is falsy or empty
  }
  console.log("getting round information for: ", roundId);

  return {
    url: urls.roundById(roundId),
    queryKey: `getRoundById:${roundId}`,
    options: { ...clubhouseApiHeadersV1() },
    transform: (responseJson: Round | Sg2Round) => {
      return normalize(responseJson, round).entities;
    },
    update: {
      rounds: (oldValue, newValue): RoundsEntitiesState => ({
        ...oldValue,
        ...newValue,
      }),
    },
  };
};

export const makeStartRoundMutation = (
  facilityId: string,
  simulatorId: string,
  body: StartRoundPayload,
): AppQueryConfig => ({
  url: urls.startRound(facilityId, simulatorId),
  queryKey: `startRound:${simulatorId}`,
  options: {
    ...clubhouseApiHeadersV1(),
    method: "POST",
  },
  body,
});

export const makeStartUnityGameMutation = (
  facilityId: string,
  simulatorId: string,
  body: StartUnityGameDto,
): AppQueryConfig => ({
  url: urls.startUnityGame(facilityId, simulatorId),
  queryKey: `makeStartUnityGameMutation:${simulatorId}`,
  options: {
    ...clubhouseApiHeadersV2(),
    method: "POST",
  },
  body,
});

export const makeMoveRoundMutation = (
  roundId: string,
  body: MoveRoundPayload,
): AppQueryConfig => ({
  url: urls.moveRound(roundId),
  options: {
    ...clubhouseApiHeadersV1(),
    method: "POST",
  },
  body,
});
